export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
export const POLYGON_BLOCK_EXPLORER_URL = 'https://mumbai.polygonscan.com/'
export const ETHEREUM_BLOCK_EXPLORER_URL = 'https://sepolia.etherscan.io/'
export const BINANCE_BLOCK_EXPLORER_URL = 'https://testnet.bscscan.com/'
